export default {"src":"/_next/static/media/avancy-gray.d26208a8.svg","height":478,"width":288,"blurWidth":0,"blurHeight":0};